module.exports = __webpack_public_path__ + "static/media/TimeVarianceAuthority.ce2e2a48.png";